export const OFFERS_ALIGNMENT = {
  BOTTOM: "bottom",
  CENTER: "center",
  LEFT: "left",
  MIDDLE: "middle",
  RIGHT: "right",
  TOP: "top",
};
